import { permissionCode } from "src/app/shared";
import { FeaturePermissionState } from "../permission.models";

export const storylinePermissionState: FeaturePermissionState = {
  view: [permissionCode.TASK_MANAGEMENT_STORYLINE_VIEW],
  edit: [permissionCode.TASK_MANAGEMENT_STORYLINE_EDIT],
};
